export interface GetBibliographyListRequest {
  authorityType: string
  authorityNo: string
}

export function GetBibliographyListRequestToJSON(
  value: GetBibliographyListRequest
): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    authority_no: value.authorityNo !== '' ? value.authorityNo : undefined
  }
}
